import React from "react";

const FullPageLoader = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        minWidth: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--dark-bg, #1E2A38)",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      {/* Animated Stacked logo mark — three right-aligned bars */}
      <svg
        width="52"
        height="56"
        viewBox="0 0 52 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Top bar — shortest, right-aligned */}
        <rect
          x="22"
          y="0"
          width="26"
          height="12"
          rx="2.5"
          fill="var(--primary-color, #1ec8c8)"
          opacity="0.35"
        >
          <animate
            attributeName="opacity"
            values="0.35;1;0.35"
            dur="1.4s"
            begin="0s"
            repeatCount="indefinite"
          />
        </rect>

        {/* Middle bar — medium, right-aligned */}
        <rect
          x="10"
          y="18"
          width="38"
          height="12"
          rx="2.5"
          fill="var(--primary-color, #1ec8c8)"
          opacity="0.35"
        >
          <animate
            attributeName="opacity"
            values="0.35;1;0.35"
            dur="1.4s"
            begin="0.2s"
            repeatCount="indefinite"
          />
        </rect>

        {/* Bottom bar — widest, right-aligned */}
        <rect
          x="0"
          y="36"
          width="48"
          height="12"
          rx="2.5"
          fill="var(--primary-color, #1ec8c8)"
          opacity="0.35"
        >
          <animate
            attributeName="opacity"
            values="0.35;1;0.35"
            dur="1.4s"
            begin="0.4s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>

      {/* Subtle brand text */}
      <span
        style={{
          color: "var(--primary-color, #1ec8c8)",
          fontSize: "11px",
          fontWeight: 500,
          letterSpacing: "3px",
          textTransform: "uppercase",
          opacity: 0.5,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        Stacked
      </span>
    </div>
  );
};

export default FullPageLoader;
